import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderAlternativeSharedComponent } from './header.alternative.component';

import { BadgeSharedModule } from '../../atoms/badge/badge.module';
import { NavDropdownSharedModule } from '../../molecules/nav.dropdown/nav.dropdown.module';

@NgModule({
    declarations: [
        HeaderAlternativeSharedComponent
    ],
    imports: [
        CommonModule,
        BadgeSharedModule,
        NavDropdownSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        HeaderAlternativeSharedComponent
    ]
})

export class HeaderAlertnativeSharedModule {}
